<template>
  <div class="row clearfix row-deck">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card">
        <div class="body text-center">
          <div>
            <span
            ><img
              src="@/assets/images/sm/avatar1.jpg"
              alt="user"
              class="rounded-circle"
            /></span>
          </div>
          <h6><b>인증</b></h6>
          <ul
            class="social-links list-unstyled"
            v-for="(auth, index) in authList"
            v-bind:key="index"
          >
            <li>{{ auth.apiName }}</li>
            <br />
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card">
        <div class="body text-center">
          <div>
            <span
            ><img
              src="@/assets/images/sm/avatar4.jpg"
              alt="user"
              class="rounded-circle"
            /></span>
          </div>
          <h6><b>트리거</b></h6>
          <ul
            class="social-links list-unstyled"
            v-for="(trig, index) in trigList"
            v-bind:key="index"
          >
            <li>{{ trig.apiName }}</li>
            <br />
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div class="card">
        <div class="body text-center">
          <div>
            <span
            ><img
              src="@/assets/images/sm/avatar3.jpg"
              alt="user"
              class="rounded-circle"
            /></span>
          </div>
          <h6><b>액션</b></h6>
          <ul
            class="social-links list-unstyled"
            v-for="(act, index) in actList"
            v-bind:key="index"
          >
            <li>{{ act.apiName }}</li>
            <br />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'DevelopAppPage',
  components: {
  },
  data() {
    return {
      authList: [],
      trigList: [],
      actList: [],
    }
  },
  methods: {
    changeStatus(type) {
      console.log("inte" + type);
    },
  },
  created() {
    console.log('DevelopAppPage created')
    var param = {
      appCode: this.$store.state.devStore.appData.appCode,
      versionCode: this.$store.state.devStore.appData.versionCode,
    }

    this.api.selectApi(param)
      .then((res) => {

        if(this.utils.preApiHandle(res)) {
          console.log("dev create page res : ", res)
        }


        var api = res.api

        var authList = []
        var trigList = []
        var actList = []

        if (api != null) {
          for (var i = 0; i < api.length; i++) {
            console.log(api[i]);
            if (api[i].apiType != "trigger" && api[i].apiType != "action") {
              authList.push(api[i]);
            } else if (api[i].apiType == "trigger") {
              trigList.push(api[i]);
            } else if (api[i].apiType == "action") {
              actList.push(api[i]);
            }
          }
        }

        this.authList = authList;
        this.trigList = trigList;
        this.actList = actList;

        this.$store.dispatch("setApiDataAll", { auth : authList, trig : trigList, act : actList})

        //
        // this.$store.state.devStore.apiAuth = authList;
        // this.$store.state.devStore.apiTrig = trigList;
        // this.$store.state.devStore.apiAct = actList;


      })
      .catch(() => {
        alert("오류가 발생했습니다. dev integration home")
        //location.href = "/";

      } );
  },
  mounted() {
    console.log('DevelopAppPage created')
  },
  beforeDestroy() {
    console.log('DevelopAppPage beforeDestroy')
  }
}
</script>

